import { render, staticRenderFns } from "./FormResultListQuestionnaireRegistrants.vue?vue&type=template&id=498201ad&"
import script from "./FormResultListQuestionnaireRegistrants.vue?vue&type=script&lang=js&"
export * from "./FormResultListQuestionnaireRegistrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports